import { generateInsightsWithGemini, evaluateWithDeepSeek, generateInsightsWithClaude } from './GeminiClient';

function patchOrAppendChatSections(prevChats, newObj, keysToAdd) {
  // If no chatSections yet, create the first element
  if (prevChats.length === 0) {
    localStorage.setItem('isEnabled', false);
    return [newObj];
  }
  let isEnabled = localStorage.getItem('isEnabled');
  // If localStorage 'isEnabled' is true => create new element
  if (isEnabled === 'true') {
    // console.log('patch prevChats', prevChats);
    const updated = [...prevChats];
    // console.log('patch updated', updated);
    updated.push(newObj);
    // console.log('patch updated', updated);
    localStorage.setItem('isEnabled', false);
    return updated;
  }
  // Otherwise, patch the last element in the array
  const updated = [...prevChats];
  // console.log('patch [...prevChats]', [...prevChats]);
  // console.log('patch updated', updated);
  const lastIndex = updated.length - 1;
  // console.log('patch lastIndex', lastIndex);
  const lastElem = updated[lastIndex];
  // console.log('patch lastElem', lastElem);
  updated[lastIndex] = { ...lastElem, ...keysToAdd };
  // console.log('patch ...lastElem', lastElem);
  // console.log('patch ...keysToAdd', keysToAdd);
  // console.log('patch updated[lastIndex]', updated[lastIndex]);
  return updated;
}

const ActorCriticAnalysis = ({ subtopics, DeepSearch, articleshook, question, loopCount, setThinkingobj, setIter1Hook,
  setFinalSummaryhook, chatSections, setChatSections, setAPIError, signal,
  setIsLoading,
  apiError, 
  Actor_Model_apiProvider, setActor_Model_apiProvider,
  Critic_Model_apiProvider, setCritic_Model_apiProvider,
  Actor_Model_apiModel, setActor_Model_apiModel,
  Critic_Model_apiModel, setCritic_Model_apiModel,
  Actor_Model_apikey, setActor_Model_apikey,
  Critic_Model_apikey, setCritic_Model_apikey,
  temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
  temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
}) => {
  const actorCriticAnalysis = async () => {
    if (signal?.aborted) {
      setThinkingobj((prevState) => {
        const newObj = { ...prevState, error: true, loading: false, timout_err: false };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
        });
        return newObj;
      });
      throw new Error('Analysis aborted')
    }
    let actor_model;
    let first_model = Actor_Model_apiProvider
    if (first_model === 'Deepseek') {
      actor_model = (prompt, setAPIError, signal) => evaluateWithDeepSeek(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        // Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        // Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        // Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
    } else if (first_model === 'Google Gemini') {
      actor_model = (prompt, setAPIError, signal) => generateInsightsWithGemini(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        // Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        // Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        // Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
    } else if (first_model === 'Anthropic') {
      actor_model = (prompt, setAPIError, signal) => generateInsightsWithClaude(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        // Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        // Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        // Critic_Model_apikey, setCritic_Model_apikey,
        parseFloat(temperature_val_Actor_Model_apiProvider), setTemperature_val_Actor_Model_apiProvider,
        // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
    }

    let critic_model;
    let second_model = Critic_Model_apiProvider
    if (second_model === 'Deepseek') {
      critic_model = (prompt, setAPIError, signal) => evaluateWithDeepSeek(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
    } else if (second_model === 'Google Gemini') {
      critic_model = (prompt, setAPIError, signal) => generateInsightsWithGemini(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
    } else if (second_model === 'Anthropic') {
      critic_model = (prompt, setAPIError, signal) => generateInsightsWithClaude(prompt, setAPIError, signal, setThinkingobj, setChatSections,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Critic_Model_apikey, setCritic_Model_apikey,
        parseFloat(temperature_val_Critic_Model_apiProvider), setTemperature_val_Critic_Model_apiProvider
      );
    }

    try {
      // 1) Stage: 'starting_analysis'
      setThinkingobj((prevState) => {
        const newObj = { ...prevState, actor: first_model, critic: second_model, stage: 'Starting Analysis...', loading: true, timout_err: false };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, { actor: first_model, critic: second_model, stage: 'Starting Analysis...', loading: true, timout_err: false })
        });
        return newObj;
      });
      // Prepare articles for analysis output
      // const analysisArticles = articleshook?.map(([Title, Summary, URL]) => ({ Title, Summary, URL }));
      const analysisArticles = articleshook
      // console.log('[BROWSER] analysisArticles', analysisArticles)
      // 2) Generate the initial actor output with an enhanced prompt
      const actorPrompt = `
      **Input Data:**
      Articles: ${JSON.stringify(analysisArticles)}
      Topic: ${question}
      Subtopics: ${subtopics}

      As the Actor in our collaborative analysis framework, your role is to synthesize insights from the provided articles related to the topic "${question}". 

      I want you to think of yourself as an expert analyst exploring this topic through multiple dimensions. Each subtopic represents a unique lens or perspective to examine the main question.

      ${question.toLowerCase().includes('predict') || question.toLowerCase().includes('forecast') || question.toLowerCase().includes('price') ?
          `**For this prediction/forecasting task:**
      - Examine historical patterns and cycles that might repeat
      - Consider current market conditions and transitional factors
      - Project multiple scenarios (optimistic, pessimistic, and baseline) with reasoning
      - Differentiate between short-term indicators and long-term trends
      - Identify key variables that could significantly alter outcomes
      - Weigh expert opinions against underlying data
      - Draw parallels to similar historical situations` : ''}

      **Your analysis should:**
      1. **Begin with an overview** that frames the topic and introduces the multi-perspective approach
      2. **Explore each subtopic** as a distinct facet of the main question, highlighting how each perspective offers unique insights
      3. **Connect the perspectives** to show how they interact and form a comprehensive understanding
      4. **Draw evidence-based conclusions** that synthesize across all dimensions
      5. **Propose forward-thinking recommendations** (if applicable)

      Remember, our goal is to produce analysis that's both nuanced and accessible. Write in clear language with logical reasoning that allows readers to follow your thought process across multiple dimensions of the topic.

      please use approximately ${DeepSearch ? '450' : '130'} words.
      `;
      let actorOutput = await actor_model(actorPrompt, setAPIError, signal, setThinkingobj, setChatSections,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        // Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        // Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        // Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
      );
      if (signal?.aborted) {
        setThinkingobj((prevState) => {
          const newObj = { ...prevState, error: true, loading: false, timout_err: false };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
          });
          return newObj;
        });
        throw new Error('Actor output generation aborted')
      }
      // Update thinkingobj with the initial actor output
      setThinkingobj((prevState) => {
        const iterations = {
          ...prevState.iterations,
          [0]: { ...prevState.iterations?.[0], actorOutput, timestamp: new Date().toISOString() }
        };
        const newObj = { ...prevState, iterations, stage: `Received Initial Output`, loading: true, timout_err: false };
        // Patch or append chatSections
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, { iterations, stage: `Received Initial Output`, loading: true, timout_err: false });
        });
        return newObj;
      });
      // Also store to iter1Hook
      setIter1Hook((prevState) => ({
        ...prevState,
        iterations: { ...prevState.iterations, [0]: { ...prevState.iterations?.[0], actorOutput, timestamp: new Date().toISOString() } },
        stage: `Received Initial Output`
      }));

      // For each iteration: provide critic feedback and refine actor output
      for (let i = 1; i < loopCount; i++) {
        if (signal?.aborted) {
          setThinkingobj((prevState) => {
            const newObj = { ...prevState, error: true, loading: false, timout_err: false };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
            });
            return newObj;
          });
          throw new Error('Iteration aborted');
        }

        // Critic feedback with enhanced prompt
        const criticFeedbackPrompt = `
        **Input Data:**
        Actor's Analysis: ${actorOutput}
        Articles: ${JSON.stringify(analysisArticles)}
        Topic: ${question}
        Subtopics: ${subtopics}

        As the Critic in our collaborative analysis framework, your role is to provide constructive feedback that helps refine the Actor's analysis of "${question}".

        I want you to approach this as a thoughtful collaborator who's helping to strengthen the multi-dimensional analysis. Consider how effectively the Actor has explored each subtopic as a different perspective on the main question.

        ${question.toLowerCase().includes('predict') || question.toLowerCase().includes('forecast') || question.toLowerCase().includes('price') ?
            `**For this prediction/forecasting analysis, evaluate:**
        - Balance between different future scenarios
        - Clarity of timeframe distinctions
        - Contextual use of historical patterns
        - Integration of current conditions as leading indicators
        - Appropriate expression of confidence levels
        - Acknowledgment of key uncertainties
        - Treatment of contradictory expert opinions` : ''}

        **In your critique, consider:**
        1. **Perspective coverage:** Are any subtopics/perspectives underdeveloped or missing?
        2. **Perspective integration:** How well do the different angles connect to form a cohesive view?
        3. **Evidence utilization:** Are key insights from the articles being leveraged effectively across perspectives?
        4. **Logical progression:** Does the analysis build a coherent narrative across dimensions?
        5. **Clarity and accessibility:** Is the multi-faceted analysis presented in a way that's easy to follow?

        Frame your feedback as a dialogue between analysts, offering specific suggestions that acknowledge strengths while identifying opportunities for deeper multi-perspective analysis.

        please use approximately ${DeepSearch ? '450' : '130'} words.
        `;
        const criticFeedback = await critic_model(criticFeedbackPrompt, setAPIError, signal, setThinkingobj, setChatSections,
          Critic_Model_apiProvider, setCritic_Model_apiProvider,
          Critic_Model_apiModel, setCritic_Model_apiModel,
          Critic_Model_apikey, setCritic_Model_apikey,
          temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider);
        if (signal?.aborted) {
          setThinkingobj((prevState) => {
            const newObj = { ...prevState, error: true, loading: false, timout_err: false };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
            });
            return newObj;
          });
          throw new Error('Critic feedback generation aborted')
        };

        // Update thinkingobj with critic feedback
        setThinkingobj((prevState) => {
          const iterations = {
            ...prevState.iterations,
            [i]: { ...prevState.iterations?.[i], criticFeedback, timestamp: new Date().toISOString() }
          };
          const newObj = { ...prevState, iterations, stage: `Received Critique ${i}`, loading: true, timout_err: false };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { iterations, stage: `Received Critique ${i}`, loading: true, timout_err: false });
          });
          return newObj;
        });
        // Also store to iter1Hook
        setIter1Hook((prevState) => ({
          ...prevState, iterations: { ...prevState.iterations, [i]: { ...prevState.iterations?.[i], criticFeedback, timestamp: new Date().toISOString() } },
          stage: `Received Critique ${i}`
        }));

        // Actor responds to critic feedback with enhanced prompt
        const actorResponsePrompt = `
        **Input Data:**
        Critic's Feedback: ${criticFeedback}
        My Previous Analysis: ${actorOutput}
        Topic: ${question}
        Subtopics: ${subtopics}

        As the Actor responding to feedback in our collaborative analysis, reflect thoughtfully on the Critic's suggestions about your analysis of "${question}".

        Approach this as a dialogue between two systems working to refine a multi-perspective understanding. Consider how you can better illuminate the topic through the various lenses represented by each subtopic.

        ${question.toLowerCase().includes('predict') || question.toLowerCase().includes('forecast') || question.toLowerCase().includes('price') ?
            `**For this prediction/forecasting discussion:**
        - Address feedback on scenario development and probability assessment
        - Clarify your reasoning on timeframes and horizons
        - Expand on historical patterns that inform your projections
        - Elaborate on how you've weighted current factors
        - Discuss the confidence calibration in your predictions
        - Acknowledge specific uncertainties highlighted by the Critic` : ''}

        **In your response:**
        1. **Acknowledge valuable insights** from the Critic's perspective
        2. **Explain your reasoning** where you might disagree
        3. **Identify specific improvements** you'll make to strengthen the multi-dimensional analysis
        4. **Propose new connections** between perspectives that weren't previously explored
        5. **Clarify your approach** to integrating the various subtopic lenses

        This is a collaborative dialogue to enhance our understanding across multiple dimensions, so focus on how each perspective adds value to the holistic analysis.

        please use approximately ${DeepSearch ? '450' : '130'} words.
        `;
        const actorResponse = await actor_model(actorResponsePrompt, setAPIError, signal, setThinkingobj, setChatSections,
          Actor_Model_apiProvider, setActor_Model_apiProvider,
          // Critic_Model_apiProvider, setCritic_Model_apiProvider,
          Actor_Model_apiModel, setActor_Model_apiModel,
          // Critic_Model_apiModel, setCritic_Model_apiModel,
          Actor_Model_apikey, setActor_Model_apikey,
          // Critic_Model_apikey, setCritic_Model_apikey,
          temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
          // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider)
          );
        if (signal?.aborted) {
          setThinkingobj((prevState) => {
            const newObj = { ...prevState, error: true, loading: false, timout_err: false };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
            });
            return newObj;
          });
          throw new Error('Actor response generation aborted');
        }

        // Update thinkingobj with actor's response
        setThinkingobj((prevState) => {
          const iterations = { ...prevState.iterations, [i]: { ...prevState.iterations?.[i], actorResponse, timestamp: new Date().toISOString() } };
          const newObj = { ...prevState, iterations, stage: `Actor Responded to Critique ${i}`, loading: true, timout_err: false };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { iterations, stage: `Actor Responded to Critique ${i}`, loading: true, timout_err: false });
          });
          return newObj;
        });
        // Also store to iter1Hook
        setIter1Hook((prevState) => ({
          ...prevState, iterations: {
            ...prevState.iterations,
            [i]: { ...prevState.iterations?.[i], actorResponse, timestamp: new Date().toISOString() }
          },
          stage: `Actor Responded to Critique ${i}`
        }));
        // Refine actor output with enhanced prompt
        const refinePrompt = `
        **Input Data:**
        My Current Analysis: ${actorOutput}
        Critic's Feedback: ${criticFeedback}
        My Response: ${actorResponse}
        Topic: ${question}
        Subtopics: ${subtopics}

        As the Actor in our iterative improvement process, present a refined analysis of "${question}" that incorporates the insights from our dialogue.

        This is your opportunity to enhance the multi-perspective approach, viewing the topic through the different lenses represented by each subtopic. Create a more nuanced and comprehensive analysis that benefits from our collaborative exchange.

        ${question.toLowerCase().includes('predict') || question.toLowerCase().includes('forecast') || question.toLowerCase().includes('price') ?
            `**For this refined prediction/forecasting analysis:**
        - Present a more balanced treatment of possible scenarios with explicit reasoning
        - Clarify the distinction between different time horizons
        - Strengthen the connection between historical patterns and future projections
        - More explicitly weigh the impact of current conditions
        - Calibrate confidence levels appropriately across different projections
        - Address the specific uncertainties we discussed
        - Highlight the key indicators that should be monitored going forward` : ''}

        **In this refined analysis:**
        1. **Integrate the perspectives** more seamlessly, showing how the different subtopic angles complement each other
        2. **Balance the coverage** across dimensions, ensuring each subtopic lens receives appropriate attention
        3. **Strengthen the evidence base** by more effectively leveraging insights from the articles
        4. **Enhance the logical flow** between perspectives
        5. **Improve clarity** in how you present the multi-faceted nature of the topic

        This refined analysis should demonstrate the value of our iterative process and show how examining the topic from multiple angles leads to deeper understanding.

        please use approximately ${DeepSearch ? '450' : '130'} words.
        `;
        actorOutput = await actor_model(refinePrompt, setAPIError, signal, setThinkingobj, setChatSections,
          Actor_Model_apiProvider, setActor_Model_apiProvider,
          // Critic_Model_apiProvider, setCritic_Model_apiProvider,
          Actor_Model_apiModel, setActor_Model_apiModel,
          // Critic_Model_apiModel, setCritic_Model_apiModel,
          Actor_Model_apikey, setActor_Model_apikey,
          // Critic_Model_apikey, setCritic_Model_apikey,
          temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
          // temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider)
          );
        if (signal?.aborted) {
          setThinkingobj((prevState) => {
            const newObj = { ...prevState, error: true, loading: false, timout_err: false };
            setChatSections((prev) => {
              return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false });
            });
            return newObj;
          });
          throw new Error('Refined analysis generation aborted');
        }

        // Store refined analysis
        setThinkingobj((prevState) => {
          const iterations = { ...prevState.iterations, [i]: { ...prevState.iterations?.[i], refinedAnalysis: actorOutput, timestamp: new Date().toISOString() } };
          const newObj = { ...prevState, iterations, stage: `Completed Iteration ${i}`, loading: true, timout_err: false };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { iterations, stage: `Completed Iteration ${i}`, loading: true, timout_err: false });
          });
          return newObj;
        });
        // Also store to iter1Hook
        setIter1Hook((prevState) => ({
          ...prevState, iterations: { ...prevState.iterations, [i]: { ...prevState.iterations?.[i], refinedAnalysis: actorOutput, timestamp: new Date().toISOString() } },
          stage: `Completed Iteration ${i}`
        }));
      }

      // 3) Final summary with enhanced prompt
      const finalSummaryPrompt = `
      **Input Data:**
      Final Analysis: ${actorOutput}
      Topic: ${question}
      Subtopics: ${subtopics}
      
      As the Critic providing a final assessment, synthesize the key insights from our collaborative analysis of "${question}".

      Reflect on how our iterative process has led to a rich understanding of the topic by examining it through multiple perspectives represented by the subtopics.

      ${question.toLowerCase().includes('predict') || question.toLowerCase().includes('forecast') || question.toLowerCase().includes('price') ?
          `**For this prediction/forecasting summary:**
      - Distill the most probable scenarios that emerged from our analysis
      - Highlight the critical factors that will shape outcomes across timeframes
      - Present a balanced view of different possibilities
      - Emphasize the key indicators that should be monitored
      - Acknowledge remaining uncertainties
      - Offer actionable insights based on our multi-perspective analysis` : ''}

      **In your summary:**
      1. **Highlight the value** of the multi-dimensional approach we've taken
      2. **Identify the most significant insights** that emerged from examining the topic through different lenses
      3. **Show how the different perspectives** have complemented each other
      4. **Present the most compelling conclusions** drawn from the integration of multiple viewpoints
      5. **Suggest how this multi-faceted understanding** could inform decisions or future explorations

      This summary should demonstrate how our collaborative, iterative analysis across multiple perspectives has yielded a more comprehensive and nuanced understanding than would have been possible from a single viewpoint.

      please use approximately ${DeepSearch ? '450' : '130'} words.
      `;
      const finalSummary = await critic_model(finalSummaryPrompt, setAPIError, signal, setThinkingobj, setChatSections,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider);
      if (signal?.aborted) {
        setThinkingobj((prevState) => {
          const newObj = { ...prevState, error: true, loading: false, timout_err: false };
          setChatSections((prev) => {
            return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: false },);
          });
          return newObj;
        });
        throw new Error('Final summary generation aborted');
      }
      setThinkingobj((prevState) => {
        const newObj = { ...prevState, finalSummary, stage: 'Analysis Completed', completedAt: new Date().toISOString(), loading: false, timout_err: false };
        setChatSections((prev) => {
          return patchOrAppendChatSections(prev, newObj, { finalSummary, stage: 'Analysis Completed', completedAt: newObj.completedAt, loading: false, timout_err: false });
        });
        return newObj;
      });
      // 4) Store final summary in finalSummaryhook
      setFinalSummaryhook(finalSummary);
    } catch (error) {
      // setThinkingobj((prevState) => {
      //   const newObj = { ...prevState, error: true, loading: false, timout_err: true };
      //   setChatSections((prev) => {
      //     return patchOrAppendChatSections(prev, newObj, { error: true, loading: false, timout_err: true });
      //   });
      //   return newObj;
      // });
      if (error.name === 'AbortError') {
        console.log('Analysis aborted:', error.message);
        // return; // Exit gracefully on abort
      }
      setAPIError(error.message);
      throw error;
    }
  };
  return { actorCriticAnalysis };
};

export default ActorCriticAnalysis;